import { noop } from './noop';

export const dateBeforeNow = (date) =>
    new Date() > new Date(date) || date === noop();
